import numeral from 'numeral';
import { ValueType, WurValueType } from '#types/generated/graphql';

type ValueFormatterArgs = {
  value?: number | null;
  valueType?: WurValueType | ValueType;
  imputed?: boolean | Maybe<boolean>;
  imputedValues?: 'hidden' | 'shown';
  addCurrencyCodeToCurrencyValues?: boolean;
  pppToUsd?: number;
  currency?: string;
};

export const roundNumber = (value?: number | null, decimal = 0): number => {
  if (!value && value !== 0) {
    return 0;
  }
  return Number(value.toFixed(decimal));
};

export const numberWithCommas = (x: number) => {
  const rounded = roundNumber(x);
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const isEmpty = (value: any) => {
  if (Array.isArray(value)) {
    return !value.length;
  }
  return !value;
};

export const valueFormatter = ({
  value,
  valueType,
  imputed = false,
  imputedValues,
  addCurrencyCodeToCurrencyValues,
  currency,
}: ValueFormatterArgs) => {
  const formatValue = () => {
    if (typeof value === 'undefined' || value === null) {
      switch (valueType) {
        case WurValueType.Reputation:
        case ValueType.Reputation:
          return '0.0';
        default:
          return 'N/A';
      }
    }

    switch (valueType) {
      case WurValueType.Currency:
      case ValueType.Currency:
        return addCurrencyCodeToCurrencyValues
          ? `${numeral(value).format('0,0')}${currency ? ` ${currency}` : ''}`
          : `${numeral(value).format('0,0')}`;
      case WurValueType.Percentage:
      case ValueType.Percentage:
      case WurValueType.Elsevier:
      case ValueType.Elsevier:
        return numeral(value).format('0.0%');
      case WurValueType.Reputation:
      case ValueType.Reputation:
      case WurValueType.Portal:
      case ValueType.Portal:
        return numeral(value).format('0.0');
      default:
        if (value === 0) {
          return '0';
        }
        return numeral(value).format('0.00');
    }
  };

  if (valueType === WurValueType.Na || valueType === ValueType.Na) {
    return 'N/A';
  }

  if (imputedValues === 'hidden' && imputed) {
    return '-';
  } else if (imputedValues === 'shown' && imputed) {
    return formatValue();
  } else if (
    imputed &&
    !(
      valueType === WurValueType.Reputation ||
      valueType === WurValueType.Elsevier ||
      valueType === ValueType.Reputation ||
      valueType === ValueType.Elsevier ||
      ((valueType === WurValueType.Currency ||
        valueType === ValueType.Currency) &&
        value !== null) ||
      ((valueType === WurValueType.Percentage ||
        valueType === ValueType.Percentage) &&
        value !== null) ||
      ((valueType === WurValueType.Untyped ||
        valueType === ValueType.Untyped) &&
        value !== null)
    )
  ) {
    return '-';
  }

  return formatValue();
};
